var React = require('react');

function IconDelete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M19.929 11v13.333H9.071V11h10.858m-2.036-8h-6.786L9.75 4.333H5V7h19V4.333h-4.75zm4.75 5.333H6.357v16A2.7 2.7 0 0 0 9.071 27h10.858a2.7 2.7 0 0 0 2.714-2.667z","transform":"translate(-3 -3)","key":1})]);
}

IconDelete.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconDelete;

IconDelete.default = IconDelete;
